// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__125vn","type":"styles_type__2kVIb","choices":"styles_choices__1mTNs"};